import { render, staticRenderFns } from "./pages-footer.vue?vue&type=template&id=709107a2&scoped=true&"
import script from "./pages-footer.vue?vue&type=script&lang=js&"
export * from "./pages-footer.vue?vue&type=script&lang=js&"
import style0 from "./pages-footer.vue?vue&type=style&index=0&id=709107a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709107a2",
  null
  
)

export default component.exports